export const DomainsActionTypes = {
  GET_DOMAINS_FAILURE: 'GET_DOMAINS_FAILURE_DOMAINS_SAGAS',
  GET_DOMAINS_REQUEST: 'GET_DOMAINS_REQUEST_DOMAINS_SAGAS',
  GET_DOMAINS_SUCCESS: 'GET_DOMAINS_SUCCESS_DOMAINS_SAGAS',
  SET_DOMAINS: 'SET_DOMAINS_DOMAINS_SAGAS',

  SET_DOMAIN_DETAIL: 'SET_DOMAIN_DETAIL',
  GET_DOMAIN_DETAIL_REQUEST: 'GET_DOMAIN_DETAIL_REQUEST',
  GET_DOMAIN_DETAIL_SUCCESS: 'GET_DOMAIN_DETAIL_SUCCESS',
  GET_DOMAIN_DETAIL_FAILURE: 'GET_DOMAIN_DETAIL_FAILURE',

  DOMAIN_ACTIVATE_RENEWAL_FAILURE: 'DOMAIN_ACTIVATE_RENEWAL_FAILURE',
  DOMAIN_ACTIVATE_RENEWAL_REQUEST: 'DOMAIN_ACTIVATE_RENEWAL_REQUEST',
  DOMAIN_ACTIVATE_RENEWAL_SUCCESS: 'DOMAIN_ACTIVATE_RENEWAL_SUCCESS',

  DOMAIN_GENERATE_NEW_INVOICE_FAILURE: 'DOMAIN_GENERATE_NEW_INVOICE_FAILURE',
  DOMAIN_GENERATE_NEW_INVOICE_REQUEST: 'DOMAIN_GENERATE_NEW_INVOICE_REQUEST',
  DOMAIN_GENERATE_NEW_INVOICE_SUCCESS: 'DOMAIN_GENERATE_NEW_INVOICE_SUCCESS',
  DOMAIN_GENERATE_NEW_INVOICE_LOADING: 'DOMAIN_GENERATE_NEW_INVOICE_LOADING',

  SET_DOMAIN_INVOICE_ID: 'SET_DOMAIN_INVOICE_ID',

  GET_DOMAIN_PROPAGATION_STATUS_REQUEST: 'GET_DOMAIN_PROPAGATION_STATUS_REQUEST',
  GET_DOMAIN_PROPAGATION_STATUS_SUCCESS: 'GET_DOMAIN_PROPAGATION_STATUS_SUCCESS',
  GET_DOMAIN_PROPAGATION_STATUS_FAILURE: 'GET_DOMAIN_PROPAGATION_STATUS_FAILURE',
  SET_DOMAIN_PROPAGATION_STATUS: 'SET_DOMAIN_PROPAGATION_STATUS',

  GET_CONFIGURED_DOMAIN_STATUS_REQUEST: 'GET_CONFIGURED_DOMAIN_STATUS_REQUEST',
  GET_CONFIGURED_DOMAIN_STATUS_SUCCESS: 'GET_CONFIGURED_DOMAIN_STATUS_SUCCESS',
  GET_CONFIGURED_DOMAIN_STATUS_FAILURE: 'GET_CONFIGURED_DOMAIN_STATUS_FAILURE',
  SET_CONFIGURED_DOMAIN_STATUS: 'SET_CONFIGURED_DOMAIN_STATUS',
  SET_EMPTY_DOMAIN_STATUS: 'SET_EMPTY_DOMAIN_STATUS',
  SET_RESET_DOMAIN_STATUS: 'SET_RESET_DOMAIN_STATUS',
  SET_LOADED_CONFIGURED_DOMAIN_STATUS: 'SET_LOADED_CONFIGURED_DOMAIN_STATUS',

  SET_DOMAIN_HAS_CONFIGURED: 'SET_DOMAIN_HAS_CONFIGURED',
  SET_DOMAIN_HAS_CONFIGURED_SUCCESS: 'SET_DOMAIN_HAS_CONFIGURED_SUCCESS',
  SET_DOMAIN_HAS_CONFIGURED_FAILURE: 'SET_DOMAIN_HAS_CONFIGURED_FAILURE',

  SET_DOMAIN_EPP_REDIRECT: 'SET_DOMAIN_EPP_REDIRECT',

  SET_MODAL_EPP_KEY_IS_OPEN: 'SET_MODAL_EPP_KEY_IS_OPEN',
  SET_MODAL_EPP_KEY_IS_CLOSED: 'SET_MODAL_EPP_KEY_IS_CLOSED',
  SET_MODAL_EPP_KEY_IS_CHANGED: 'SET_MODAL_EPP_KEY_IS_CHANGED',

  GET_EPP_KEY_GENERATED_REQUEST: 'GET_EPP_KEY_GENERATED_REQUEST',
  GET_EPP_KEY_GENERATED_SUCCESS: 'GET_EPP_KEY_GENERATED_SUCCESS',
  GET_EPP_KEY_GENERATED_FAILURE: 'GET_EPP_KEY_GENERATED_FAILURE',
  SET_EPP_KEY_GENERATED: 'SET_EPP_KEY_GENERATED',

  GET_ALL_DOMAINS_LIST_REQUEST: 'GET_ALL_DOMAINS_LIST_REQUEST',
  GET_ALL_DOMAINS_LIST_SUCCESS: 'GET_ALL_DOMAINS_LIST_SUCCESS',
  GET_ALL_DOMAINS_LIST_FAILURE: 'GET_ALL_DOMAINS_LIST_FAILURE',
  SET_ALL_DOMAINS_LIST: 'SET_ALL_DOMAINS_LIST',

  REQUEST_DOMAINS_ELEGIBLE: 'REQUEST_DOMAINS_ELEGIBLE',
  SET_DOMAINS_ELEGIBLE: 'SET_DOMAINS_ELEGIBLE',
  DOMAINS_ELEGIBLE_SUCCESS: 'DOMAINS_ELEGIBLE_SUCCESS',
  DOMAINS_ELEGIBLE_FAILURE: 'DOMAINS_ELEGIBLE_FAILURE',

  REQUEST_CHANGE_DOMAIN: 'REQUEST_CHANGE_DOMAIN',
  SUCCESS_CHANGE_DOMAIN: 'SUCCESS_CHANGE_DOMAIN',
  SET_NEW_DOMAIN: 'SET_NEW_DOMAIN',
  RESET_CHANGE_DOMAIN_STATE: 'RESET_CHANGE_DOMAIN_STATE',
  FAILURE_CHANGE_DOMAIN: 'FAILURE_CHANGE_DOMAIN',
  LOADING_CHANGE_DOMAIN: 'LOADING_CHANGE_DOMAIN',
  SET_NEW_DOMAIN_ONBOARDING_SUMMARY: 'SET_NEW_DOMAIN_ONBOARDING_SUMMARY',

  GET_TEMPORARY_DOMAINS: 'GET_TEMPORARY_DOMAINS',
  GET_TEMPORARY_DOMAINS_SUCCESS: 'GET_TEMPORARY_DOMAINS_SUCCESS',
  GET_TEMPORARY_DOMAINS_FAILURE: 'GET_TEMPORARY_DOMAINS_FAILURE',
  SET_TEMPORARY_DOMAINS_LIST: 'SET_TEMPORARY_DOMAINS_LIST',
  SET_TEMPORARY_DOMAINS_LOADING: 'SET_TEMPORARY_DOMAINS_LOADING',

  GET_CREATE_TEMPORARY_DOMAIN: 'GET_CREATE_TEMPORARY_DOMAIN',
  GET_CREATE_TEMPORARY_DOMAIN_SUCCESS: 'GET_CREATE_TEMPORARY_DOMAIN_SUCCESS',
  GET_CREATE_TEMPORARY_DOMAIN_FAILURE: 'GET_CREATE_TEMPORARY_DOMAIN_FAILURE',
  SET_CREATE_TEMPORARY_DOMAIN_LOADING_STATUS: 'SET_CREATE_TEMPORARY_DOMAIN_LOADING_STATUS',
  SET_TEMPORARY_DOMAIN_CREATED: 'SET_TEMPORARY_DOMAIN_CREATED',

  REQUEST_REDEEM_DOMAIN: 'REQUEST_REDEEM_DOMAIN',
  SUCCESS_REDEEM_DOMAIN: 'SUCCESS_REDEEM_DOMAIN',
  FAILURE_REDEEM_DOMAIN: 'FAILURE_REDEEM_DOMAIN',
  LOADING_REDEEM_DOMAIN: 'LOADING_REDEEM_DOMAIN',
  RESET_REDEEM_DOMAIN: 'RESET_REDEEM_DOMAIN',

  GET_AVAILABLE_DOMAIN_TLDS: 'GET_AVAILABLE_DOMAIN_TLDS',
  AVAILABLE_DOMAIN_TLDS_SUCCESS: 'AVAILABLE_DOMAIN_TLDS_SUCCESS',
  AVAILABLE_DOMAIN_TLDS_FAILURE: 'AVAILABLE_DOMAIN_TLDS_FAILURE',
  SET_AVAILABLE_DOMAIN_TLDS: 'SET_AVAILABLE_DOMAIN_TLDS',
  SET_AVAILABLE_DOMAIN_TLDS_LOADING: 'SET_AVAILABLE_DOMAIN_TLDS_LOADING',

  REQUEST_CHECK_PROVIDER: 'REQUEST_CHECK_PROVIDER',
  CHECK_PROVIDER_SUCCESS: 'CHECK_PROVIDER_SUCCESS',
  CHECK_PROVIDER_FAILURE: 'CHECK_PROVIDER_FAILURE',
  SET_CHECK_PROVIDER: 'SET_CHECK_PROVIDER',
  SET_CHECK_PROVIDER_LOADING: 'SET_CHECK_PROVIDER_LOADING',
  RESET_CHECK_PROVIDER: 'RESET_CHECK_PROVIDER',

  REQUEST_DOMAIN_AVAILABILITY: 'REQUEST_DOMAIN_AVAILABILITY',
  SET_DOMAIN_AVAILABILITY: 'SET_DOMAIN_AVAILABILITY',
  DOMAIN_AVAILABILITY_SUCCESS: 'DOMAIN_AVAILABILITY_SUCCESS',
  DOMAIN_AVAILABILITY_FAILURE: 'DOMAIN_AVAILABILITY_FAILURE',
  LOADING_DOMAIN_AVAILABILITY: 'LOADING_DOMAIN_AVAILABILITY',
  RESET_DOMAIN_AVAILABILITY: 'RESET_DOMAIN_AVAILABILITY',
  RESET_CURRENT_RADIX_DOMAIN_AVAILABILITY: 'RESET_CURRENT_RADIX_DOMAIN_AVAILABILITY',

  GET_DOMAINS_REDEEM_AVAILABILITY: 'GET_DOMAINS_REDEEM_AVAILABILITY',
  GET_DOMAINS_REDEEM_AVAILABILITY_SUCCESS: 'GET_DOMAINS_REDEEM_AVAILABILITY_SUCCESS',
  GET_DOMAINS_REDEEM_AVAILABILITY_FAILURE: 'GET_DOMAINS_REDEEM_AVAILABILITY_FAILURE',
  SET_DOMAINS_REDEEM_AVAILABILITY: 'SET_DOMAINS_REDEEM_AVAILABILITY',
  RESET_DOMAINS_REDEEM_AVAILABILITY: 'RESET_DOMAINS_REDEEM_AVAILABILITY',

  GET_DOMAINS_TO_BUY_REQUEST: 'GET_DOMAINS_TO_BUY_REQUEST',
  GET_DOMAINS_TO_BUY_SUCCESS: 'GET_DOMAINS_TO_BUY_SUCCESS',
  GET_DOMAINS_TO_BUY_FAILURE: 'GET_DOMAINS_TO_BUY_FAILURE',
  GET_DOMAINS_TO_BUY_LOADING: 'GET_DOMAINS_TO_BUY_LOADING',

  REQUEST_BUY_DOMAIN: 'REQUEST_BUY_DOMAIN',
  LOADING_BUY_DOMAIN: 'LOADING_BUY_DOMAIN',
};

export const CHANGE_DOMAIN_CODES = {
  HOSTING_NOT_AVAILABLE: 'HOSTING_NOT_AVAILABLE',
  SAME_DOMAIN: 'SAME_DOMAIN',
  NOT_UPDATE_DOMAIN_IN_CPANEL_HOSTING: 'NOT_UPDATE_DOMAIN_IN_CPANEL_HOSTING',
};
